import Barometer from "../../components/barometer.vue";
import KerncijfersChart from "./components/kerncijfers/kerncijfers-chart.vue";
import Page from "../../lib/Page";
import Ajax from "../../lib/Ajax";
import Toast from "../../lib/Toast";
import FavouriteStar from '../../components/favourite-star.vue';
import MandateTimeline from '../../components/mandate-timeline.vue';
import VuePieChart from "../../components/vue-pie-chart.vue";
import NavigationBar from "./components/navigation-bar.vue";
import Directors from "./components/directors.vue";
import Mandates from "./components/directors.vue";
import Extern from "./components/directors.vue";
import Participations from "./components/participations.vue";
import Locations from "./components/locations.vue";
import Timeline from './components/timeline.vue';
import Kyc from './components/kyc.vue';
import KycReportWrapper from './components/kyc-report-wrapper.vue';
import AddToAlertsModal from '../../components/add-to-alerts-modal.vue';
import FinancialStatements from './components/financial-statements.vue';
import {useDetailStore} from "./store";
import Tooltip from "../../components/tooltip.vue";
import VopDrawer from "./components/vop-drawer.vue";
import {KernCijferCategory, SubPage, TableKernCijfer, Warning} from "./types";
import ScoreGraph from "../radar/components/score-graph.vue";
import CompanyComparisonWidget from "./components/company-comparison-widget.vue";
import LeafletMap from '../../components/leaflet-map.vue';
import {createVueInstance} from "../../vue-root";
import {defineComponent} from 'vue';

enum KernCijferView {
    TABLE,
    CHART
}
const app = defineComponent({
    name: 'company-page',
    el: document.querySelector("[vue-root]")!,
    data() {
      return {
          KernCijferView,
          currentKernCijferView: KernCijferView.TABLE,
          containingAlertListIds: window.cw.containingAlertLists as number[],
          alertLists: window.cw.alertLists,
          isFavourite: window.cw.isFavourite as boolean,
          listIds: window.cw.alertsListIds as number[],
          vat: window.cw.vat,
          cwId: window.cw.cwId,
          isRapportMenuOpen: false,
          isExternalLinksMenuOpen: false,
          errataForm: {
              contactFullName: window.cw.contactFullName as string,
              contactEmail: window.cw.contactEmail as string,
              contactPhone: window.cw.contactPhone as string,
              erratum: '',
              description: window.cw.companyDescription as string,
              email: window.cw.companyEmail as string,
              phone:  window.cw.companyPhone as string,
              website:  window.cw.companyWebsite as string
          },
          errataLoading: false,
          warningIndex: 0,
          detailStore: useDetailStore(),
          lastScrollTop: 0,
          warnings: (window.cw.warnings ?? []) as Warning[],
          showAllPubs: false
      }  
    },
    components: {
        ScoreGraph,
        KerncijfersChart,
        Barometer,
        FavouriteStar,
        MandateTimeline,
        VuePieChart,
        NavigationBar,
        Directors,
        Mandates,
        Extern,
        Participations,
        Locations,
        Timeline,
        Kyc,
        FinancialStatements,
        Tooltip,
        AddToAlertsModal,
        CompanyComparisonWidget,
        KycReportWrapper,
        VopDrawer,
        LeafletMap
    },
    computed: {
        yThreshold(): number{
            const nav = document.getElementById("notScrolledNavBar");
            return nav ? (nav.offsetTop - nav.clientHeight) : 0;
        },
        isInAlerts(): boolean {
            return this.containingAlertListIds.length > 0;
        },
        warning(): Warning | null {
            return this.warnings.length > 0 ? this.warnings[this.warningIndex] : null;
        }
    },
    methods: {
        copyToClipboard(text:string): void {
            window.navigator.clipboard.writeText(text);
            Toast.info(this.translate("copy_success"));
        },
        togglePubs(){
            const wrapper = document.getElementById("pubWrapper");
            this.showAllPubs = !this.showAllPubs;
            
            if(wrapper && !this.showAllPubs) {
                window.scrollTo({ top: wrapper.offsetTop - 120, behavior: 'smooth' });
            }
        },
        setWarning(index: number): void {
            this.warningIndex = index;
            this.store.openDrawer(this.store.Drawer.WARNING_DETAIL);
        },
        nextWarning() {
            if(this.warningIndex >= this.warnings.length)
                return;
            
            this.warningIndex++;
        },
        prevWarning() {
            if(this.warningIndex === 0)
                return;
            
            this.warningIndex--;
        },
        async onErrataSubmit(): Promise<void> {
            this.errataLoading = true;
            await Ajax.postAsync("/ajax/company/edit", {
                vat: this.vat,
                cwId: this.cwId,
                ...this.errataForm
            });

            this.errataLoading = false;
            Toast.success(this.translate('errata_confirmation'));

            this.store.closeModal();
        },
        openAlertsModal(): void {
           this.store.openModal(this.store.modals.ADD_TO_ALERTS);
        },
        closeAlertsModal(): void {
            this.store.closeModal();
        },
        handleScroll(): void {
            const isScrollingDown = window.scrollY >  this.lastScrollTop;
            const el = (this.$refs.scrolled as HTMLDivElement);
            this.lastScrollTop = window.scrollY;
            
            if(!el)
                return;
            
            if(this.lastScrollTop > this.yThreshold && isScrollingDown) {
                el.classList.remove("hidden");
                this.detailStore.isInScrolledView = true;
            } else if(!isScrollingDown && this.lastScrollTop <= this.yThreshold) {
                el.classList.add("hidden");
                this.detailStore.isInScrolledView = false;
            }
        },
        scrollToTop(): void {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    async mounted() {
        Page.applyBehaviors("[vue-root]");
        await this.detailStore.setPage(window.cw.subPage as SubPage);

        // on browser back
        // careful: other callbacks to onpopstate will consume the event and will render the callback below useless.
        window.onpopstate = async (event) => {
            const page = event.state?.page ?? SubPage.GENERAL;
            this.store.closeModal();
            await this.detailStore.setPage(page);
            Page.applyBehaviors("[vue-root]");
        };
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    unmounted () {
        window.removeEventListener('scroll', this.handleScroll);
    }
});
createVueInstance(app);